import React from "react";
import "../style/tour.css";
import aboutSection3image from "../assets/aboutSection3image.jpg";
import { FaPhone } from "react-icons/fa";
import ImageGallery from "./ImageGallery1";
import outside from "../assets/outside .mp4";
import back from "../assets/back .mp4";
import backsit from "../assets/backsit.mp4";
import ImageGallery2 from "./ImageGallery2";

import ContentBlock from "./ContentBlock";

const Tour = () => {
  return (
    <div className="tour-container">
      <section className="tour-section1">
        <h1>A Home-Like Environment</h1>
      </section>
      <section className="tour-section2">
        <div className="tour-section2-div1">
          <div className="tour-section2-div1-item1">
            <img src={aboutSection3image} alt="about" loading="lazy" />
          </div>
          <div className="tour-section2-div1-item2">
            <h1>Serenity Facility</h1>
            <span>
              Our facilities are designed to feel like home while providing all
              the professional care and support needed. We believe that
              environment plays a crucial role in well-being and quality of
              life.
            </span>
            <span>
              Each of our residences features comfortable common areas,
              accessible design, beautiful gardens, and all the amenities needed
              for daily life and social activities.
            </span>
          </div>
        </div>
      </section>

      <section className="tour-section3">
        <h4>Vincent House</h4>
        <div className="tour-section3-div1">
          <div className="tour-section3-div1-item1">
            “Take a glimpse into life at Serenity Residential Care. View the
            welcoming spaces, the homely environment, and the compassionate care
            that makes our community special. Here, every detail is designed to
            ensure comfort, dignity, and a true sense of belonging.”
          </div>
          <div className="tour-section3-div1-item2">
            <video
              controls
              width="100%"
              height="400"
              poster="/videoicon1.png"
              className="tour-section3-video"
            >
              <source src={outside} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </section>

      <section className="tour-section4">
        <ContentBlock>
          <ImageGallery />
        </ContentBlock>
      </section>

      <section className="tour-section5">
        <h1>
          Life at Serenity Residential Care is about more than support—it’s
          about living well every day.
        </h1>
        <div className="tour-section3-div1-item2">
          <video
            controls
            width="100%"
            height="400"
            poster="/videoicon2.png"
            className="tour-section3-video"
          >
            <source src={back} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </section>

      <section className="tour-section6">
        <ContentBlock>
          <ImageGallery2 />
        </ContentBlock>

        <div className="tour-section3-div1-item2">
          <video
            controls
            width="100%"
            height="400"
            poster="/videoicon3.png"
            className="tour-section3-video"
          >
            <source src={backsit} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <h4 className="tour-section6-h4">
            we blend professional care with a homely atmosphere, meaningful
            activities, and warm relationships that help residents feel valued
            and at home.
          </h4>
        </div>
      </section>

      <section className="home-section5">
        <div className="home-section5-div1">
          <h1>Learn More About Our Services</h1>
          <h3>
            Contact us today to discuss how our services can support you or your
            loved
            <br /> one. We're here to answer questions and provide guidance.
          </h3>
          <p>
            <span> Contact Us Today</span> <FaPhone />
            <a href="tel:+[234][81313843]" className="footer-link">
              0121 769 3243
            </a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default Tour;
